<template>
  <div>
    <van-nav-bar
      title="考试"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-cell-group>
      <van-field
        v-model="examInfo.name"
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="examInfo.quserid"
        label="身份证"
        placeholder="请输入身份证号"
      />
      <van-field
        readonly
        clickable
        label="性别"
        :value="sexVal"
        placeholder="选择性别"
        @click="showPicker = true"
      />
      <van-field
        readonly
        clickable
        label="学历"
        :value="eduVal"
        placeholder="选择学历"
        @click="eduShow = true"
      />

      <van-field
        v-model="examInfo.occupation"
        label="职业岗位"
        placeholder="请输入职业岗位"
      />
      <van-field
        v-model="examInfo.phone"
        label="联系方式"
        placeholder="请输入联系方式"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>地址</span></div>
        <v-distpicker
          class="addPick"
          @province="provinceChange"
          @city="cityChange"
          @area="areaChange"
          :province="examInfo.province"
          :city="examInfo.city"
          :area="examInfo.area"
        ></v-distpicker>
      </div>

      <van-field
        v-model="examInfo.address"
        label="详情地址"
        placeholder="请输入详情地址(方便证书邮寄)"
      />
      <van-field
        readonly
        clickable
        label="考试"
        :value="examName"
        placeholder="选择考试"
        @click="examShow = true"
      />
      <!-- 选择优惠 -->
      <van-field
        readonly
        clickable
        label="优惠"
        :value="discountName"
        placeholder="请选择优惠"
        @click="disShow = true"
        v-show="examDiscount.length > 0"
      />
      <!-- 支付 -->
      <van-checkbox-group
        v-model="result"
        v-show="examName != ''"
        class="m-t-10"
      >
        <van-cell-group>
          <van-cell
            v-for="(item, index) in list"
            clickable
            :key="item"
            :title="` ${item}`"
            @click="toggle(index)"
            v-show="payShow(index)"
          >
            <template #right-icon>
              <van-checkbox :name="item" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-cell-group>
    <div style="width: 90%; margin-left: 5%">
      <van-button type="primary" block class="m-t-10" @click="addExamInfo"
        >去支付</van-button
      >
    </div>
    <!-- 学历 -->
    <van-popup v-model="eduShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="eduLsit"
        value-key="name"
        @cancel="eduShow = false"
        @confirm="eduConfirm"
      />
    </van-popup>
    <!-- 性别 -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="sex"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 考试 -->
    <van-popup v-model="examShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="examList"
        value-key="name"
        @cancel="examShow = false"
        @confirm="examConfirm"
      />
    </van-popup>
    <!-- 选择优惠 -->
    <van-popup v-model="disShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="examDiscount"
        @cancel="disShow = false"
        @confirm="disConfirm"
      />
    </van-popup>
    <Pay ref="pay" />
  </div>
</template>



<script>
import Pay from "@/components/pay/pay";
import { getAppClient } from "@/utils/commonUtils";

export default {
  components: {
    Pay,
  },
  data() {
    return {
      sexVal: "男",
      eduVal: "本科",
      eduLsit: [
        { id: "0", name: "高中" },
        { id: "1", name: "中专" },
        { id: "2", name: "大专" },
        { id: "3", name: "本科" },
        { id: "4", name: "研究生" },
        { id: "5", name: "博士及博士后" },
      ],
      eduShow: false,
      showPicker: false,
      examShow: false,
      columns: [
        { id: "1", sex: "男" },
        { id: "2", sex: "女" },
      ],
      examName: "",
      examInfo: {
        name: "",
        userID: this.uid(),
        sex: "1",
        phone: "",
        education: "3",
        occupation: "",
        province: "北京市", // 省
        city: "北京市", // 市
        area: "海淀区", // 区
        address: "", // 详细地址
        examid: "",
        quserid: "",
        classid: "",
      },
      payType: 0,
      list: ["微信", "支付宝"],
      result: ["微信"],
      examList: [],
      examDiscount: [],
      discountName: "",
      disShow: false,
      newInfo: "",
      examMoney: 0,
      dicMoney: 0,
      jsFlag: true,
      examid: "",
      orderNumber: "",
      lookPay: "",
    };
  },
  created() {
    if (getAppClient() == "JSAPI") {
      this.jsFlag = false;
      return false;
    }
    this.getExamList();
    if (this.$route.query.id != undefined) {
      this.examid = this.$route.query.id;
      this.getUserExamInfoById();
    }
    if (this.$route.query.orderNumber != undefined) {
      this.orderNumber = this.$route.query.orderNumber;
      this.getOrderType();
      this.lookPay = setInterval(() => {
        this.getOrderType();
      }, 2000);
    }
    this.getUserInfo();
  },
  methods: {
    getOrderType() {
      let data = {
        id: this.orderNumber,
      };
      this.ApiNew.Exam.getPatType(data).then((res) => {
        if (res.retuCode == 5000) {
          if (res.data.payStater == 1) {
            return;
          } else if (res.data.payStater == 2) {
            this.$toast("支付成功");
            this.$router.push({
              path: "/agreementList",
            });
          }
        } else {
          this.getOrderType();
        }
      });
    },
    payShow(i) {
      if (i == 1 && this.payFlag) return false;
      return true;
    },
    // 获取用户报名信息
    getUserExamInfoById() {
      let data = {
        id: this.examid,
      };
      this.ApiNew.Exam.getUserExamInfoById(data).then((res) => {
        if (res.retuCode == 5000) {
          this.examInfo.examid = res.data.examid;
          this.examInfo.classid = res.data.classid;
          this.examName = res.data.examName;
          this.discountName = res.data.exanName;
        }
      });
    },
    // 优惠选择
    disConfirm(val) {
      this.disShow = false;
      this.examInfo.classid = val.id;
      this.discountName = val.name;
      this.dicMoney = val.discount;
    },
    // 提交信息
    addExamInfo() {
      if (this.examInfo.name == "") {
        this.$toast("请输入姓名");
        return false;
      }
      if (this.examInfo.quserid == "") {
        this.$toast("请输入身份证号");
        return false;
      }
      if (this.examInfo.occupation == "") {
        this.$toast("请输入职业岗位");
        return false;
      }
      if (this.examInfo.phone == "") {
        this.$toast("请输入手机号");
        return false;
      }
      if (this.examInfo.address == "") {
        this.$toast("请输入详情地址");
        return false;
      }
      if (this.examInfo.examid == "") {
        this.$toast("请选择报名的考试");
        return false;
      }
      this.ApiNew.Exam.addExamInfo(this.examInfo).then((res) => {
        if (res.retuCode == 5000) {
          this.$refs.pay.orderId =
            this.examid != "" ? this.examid : res.data.id;
          this.$refs.pay.payFlag = this.result[0] == "微信" ? "1" : "2";
          this.$refs.pay.goPay();
        }
      });
    },
    // 获取考试的全部列表
    getExamList() {
      this.ApiNew.Exam.getExamList().then((res) => {
        if (res.retuCode == 200) {
          this.examList = res.data;
        }
      });
    },
    // 获取用户信息
    getUserInfo() {
      let data = {
        userId: this.uid(),
      };
      this.ApiNew.Exam.getUserInfo(data).then((res) => {
        if (res.retuCode == 200) {
          if (this.$route.query.id != undefined) {
            res.data.examid = "";
            res.data.classid = "";
          }
          this.examInfo = res.data;
          if (this.newInfo != "") {
            this.examInfo = this.newInfo;
          }
        }
      });
    },

    // 获取课程下的优惠列表
    getUserDiscount() {
      let data = {
        userid: this.uid(),
        examId: this.examInfo.examid,
      };
      this.ApiNew.Exam.getUserDiscount(data).then((res) => {
        if (res.data != undefined) {
          res.data.forEach((item) => {
            item.text = item.name + "-优惠：" + item.discount;
            if (this.examid != "") {
              this.discountName = item.text;
            }
          });
          this.examDiscount = res.data;
        }
      });
    },
    toggle(index) {
      if (index == 0) {
        this.$refs.checkboxes[index + 1].toggle(false);
      } else {
        this.$refs.checkboxes[0].toggle(false);
      }
      this.$refs.checkboxes[index].toggle();
      this.payType = index;
    },
    examConfirm(value) {
      this.examShow = false;
      this.examName = value.name;
      this.examInfo.examid = value.id;
      this.examMoney = value.money;
    },
    onConfirm(value) {
      if (value.id == 2) {
        this.sexVal = "女";
      } else {
        this.sexVal = "男";
      }
      this.examInfo.sex = value.id;
      this.showPicker = false;
    },
    eduConfirm(val) {
      this.eduVal = this.eduLsit[1].name;
      this.examInfo.education = val.id;
    },
    provinceChange(data) {
      //省
      this.examInfo.province = data.value;
    },
    cityChange(data) {
      //市
      this.examInfo.city = data.value;
    },
    areaChange(data) {
      //区、县
      this.examInfo.area = data.value;
    },
  },
  watch: {
    "examInfo.examid": {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val);
        if (val != "") {
          this.getUserDiscount();
        }
      },
    },
  },
};
</script>

<style scoped>
.addPick {
  widows: 60% !important;
  font-size: 20px;
  flex: 1;
}
.addPick >>> select {
  padding: 0;
  height: 25px;
  font-size: 20px;
}
</style>